import { InfoAnagrafichePFDTO } from "./info-anagrafiche-pf";
import { InfoNascitaPFDTO } from "./info-nascita-pf.dto";
import { PersonaGiuridicaDTO } from "./persona-giuridica-dto";

export class PersonaFisicaDTO {
	infoAnagrafiche: InfoAnagrafichePFDTO;
	infoNascita: InfoNascitaPFDTO;
	id: string;
	//TODO
	// dittaIndividuale: PersonaGiuridicaDTO;
}